import { ShowMojoConnectForm } from './ShowMojoConnectForm'
import type { VendorConnectorProps } from './types'

export function ShowMojoConnector({ onConnected }: VendorConnectorProps) {
  return <ShowMojoConnectForm onConnected={() => onConnected?.()} />
}
